/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DispatchProductsResponseDto } from '../../models/dispatch-products-response-dto';
import { ImportProductsDto } from '../../models/import-products-dto';

export interface ProductsControllerImport$Params {
  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id': string;
  body: ImportProductsDto;
}

export function productsControllerImport(
  http: HttpClient,
  rootUrl: string,
  params: ProductsControllerImport$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<DispatchProductsResponseDto>> {
  const rb = new RequestBuilder(rootUrl, productsControllerImport.PATH, 'post');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DispatchProductsResponseDto>;
    })
  );
}

productsControllerImport.PATH = '/api/v1/products/import';
